exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/*used for styling clause logical operation*/\r\n.clause-logical-operation{\r\n    margin :-3px;\r\n}\r\n/*used for AND-OR button display*/\r\n.lf-svg-logical-operation{\r\n    width:30px;\r\n    height:30px;\r\n}\r\n\r\n/*used for avoid pointer events*/\r\n.disable_spn {\r\n    pointer-events: none;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /var/lib/jenkins/workspace/1_SCE_CI_CD_SIT/src/app/features/setup/customer/parameter-group/custom-aggrid-cells/orand-cell-editor/orand-cell-editor.component.css
// module id = ../../../../../src/app/features/setup/customer/parameter-group/custom-aggrid-cells/orand-cell-editor/orand-cell-editor.component.css
// module chunks = main